import { useEffect, useState } from 'react';
import { useDebounce } from '@/hooks/useDebounce';
import { toFullNameParam } from '../utils/toFullNameParam';

export function useNameSearchText(
  urlFullName: string | undefined,
  onNameSearch: (nameText: string) => void,
) {
  const [nameText, setNameText] = useState(urlFullName ?? '');
  const debouncedNameText = useDebounce(nameText);
  const [lastUrlFullName, setLastUrlFullName] = useState(urlFullName);

  if (urlFullName !== lastUrlFullName) {
    setLastUrlFullName(urlFullName);
    const isOwnSearch = urlFullName === toFullNameParam(debouncedNameText);
    if (!isOwnSearch) setNameText(urlFullName ?? '');
  }

  useEffect(() => {
    onNameSearch(debouncedNameText);
  }, [debouncedNameText, onNameSearch]);

  return [nameText, setNameText] as const;
}
